import _ from 'lodash';
import React from 'react';

import FansFilterBar from './fans-filter-bar';
import FanSearchBar from './fan-search-bar';
import autobind from 'autobind-decorator';

class ManageFansHeader extends React.Component {
	render () {

		return (
			<div className="grid-x">
				<div className="grid-x cell small-12">
					<div className="cell auto padding-top-1 padding-left-1">
						<h3 data-ta="manageFansHeader">Manage Fans</h3>
					</div>
					<div className="cell shrink">
						<FanSearchBar 
							searchTerm={ this.props.searchTerm }
							searchChange={ this.props.searchChange }
							clearFunc={ this.props.clearFunc }
						/>
					</div>
				</div>

				<div className="cell small-12">
					<FansFilterBar />
				</div>
			</div>
		);
	}


}

export default ManageFansHeader;
